import React from "react";

export default function useTinyImporter() {
  const [tinyImporterOpen, setTinyImporterOpen] =
    React.useState<boolean>(false);

  const openTinyImporter = React.useCallback(() => {
    setTinyImporterOpen(true);
  }, []);

  const closeTinyImporter = React.useCallback(() => {
    setTinyImporterOpen(false);
  }, []);

  const [tinyImportDialogOpen, setTinyImportDialogOpen] = React.useState(false);

  const openTinyImportDialog = React.useCallback(() => {
    setTinyImportDialogOpen(true);
  }, []);

  const closeTinyImportDialog = React.useCallback(() => {
    setTinyImportDialogOpen(false);
  }, []);

  return {
    openTinyImportDialog,
    closeTinyImportDialog,
    tinyImportDialogOpen,
    openTinyImporter,
    closeTinyImporter,
    tinyImporterOpen,
  };
}
